/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2023-2026. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: SwalUtil.ts
 * Created by: chan.ying
 * Create Date: 2026-06-25 16:27
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

import Swal from "sweetalert2";
import SwalConfig from "@/commons/utils/SwalConfig";

export default class SwalUtil {
    public static popupNotification(config: SwalConfig) {
        return Swal.fire({
            ...config,
            showCloseButton: config.showCloseButton,
            closeButtonHtml: '<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">'
                + '<path d="M18.5 7.20857L17.2914 6L12.5 10.7914L7.70857 6L6.5 7.20857L11.2914 12L6.5 16.7914L7.70857 18L12.5 ' +
                '13.2086L17.2914 18L18.5 16.7914L13.7086 12L18.5 7.20857Z "'
                + ' fill="var(--body-color-1)"/></svg>',
            allowOutsideClick: false, // Allow outside click close dialog
            focusConfirm: false, // Confirm button loses focus
            focusCancel: false, // Cancel button loses focus
            reverseButtons: true, // Cancel left, confirm right (M3 trailing-edge confirm)
            allowEscapeKey: true, // Allow ESC to turn off message boxes
            allowEnterKey: false, // Allow carriage return submission
            backdrop: true,
            customClass: {
                popup: 'ztn-swal',
                image: 'ztn-swal-image',
                title: 'ztn-swal-title',
                htmlContainer: 'ztn-swal-htmlContainer',
                confirmButton: config.destructive
                    ? 'ztn-swal-confirmButton ztn-swal-confirmButton--danger'
                    : 'ztn-swal-confirmButton',
                cancelButton: 'ztn-swal-cancelButton',
                closeButton: 'ztn-swal-closeButton'
            },// Css style
            didOpen() {
                const confirmButton = Swal.getConfirmButton()
                const cancelButton = Swal.getCancelButton()
                if (confirmButton) {
                    confirmButton.id = 'swal-confirm-button'
                }
                if (cancelButton) {
                    cancelButton.id = 'swal-cancel-button'

                }
            },
        });
    }

    public static async verifyPopupNotification(config: SwalConfig, className: string, errorClassName: string) {
        let element = document.querySelector("." + className);

        return await SwalUtil.popupNotification(config).then(() => {
            if (element !== null) {
                element.scrollIntoView({behavior: "auto", block: "start"});
            }
        }).finally(() => {
            if (element !== null) {
                element.classList.add(errorClassName);
                setTimeout(function () {
                    if (element !== null) {
                        element.classList.remove(errorClassName);
                    }
                }, 1000);
            }
        })
    }
}